<template>
    <section ref="refProfiles" class="slice tag-page__profiles">
        <div class="slice-content">
            <h2 class="slice-title joy-mb-12">{{ currentTitle }}</h2>
            <TagPageProfilesList :profiles="profiles" />
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed, useTemplateRef} from 'vue';
    import {useTranslation, useComponentTracking} from '#imports';
    import type {FreelancerProfile} from '@api';
    import TagPageProfilesList from './TagPageProfileList.vue';

    const props = defineProps<{tag: string; profiles: FreelancerProfile[]; total?: number}>();

    const {t} = useTranslation();
    const refProfiles = useTemplateRef('refProfiles');

    const MAX_NB_RESULTS = 300;
    const currentTitle = computed(() => {
        return t('search.header.icu.title', {
            cappedNbResults: Math.min(props.total ?? 0, MAX_NB_RESULTS),
            jobLabel: props.tag,
        });
    });

    useComponentTracking(refProfiles);
</script>
